import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
import { computed } from "@vue/composition-api";
export const useMortgageDetailsDownpaymentFieldBindings = options => {
  const rootPath = computed(() => "[mortgage-details]");
  const {
    bindApplication,
    makeFieldPathReactive
  } = useBindApplication();
  const currentDownpaymentPath = computed(() => {
    return `${rootPath.value}[down-payment][${options.downpaymentIndex.value}]`;
  });
  const mortgageDetailsDownpaymentAmount = bindApplication(makeFieldPathReactive(currentDownpaymentPath, "[amount]"), 0);
  return {
    mortgageDetailsDownpaymentAmount
  };
};